import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import './Container.scss';

export const Container = ({
  full,
  extended,
  main,
  children,
  withoutOverflowX,
  narrowPadding,
  fullTabletMobile,
  ...wrapperProps
}) => {
  const container = (
    <div
      className={cn('container', {
        'container-full': full,
        'container-extended': !full && extended,
        'container-main': !full && !extended && main,
        'container-without-overflow-x': withoutOverflowX,
        'container-wide': narrowPadding,
        'container-full-tablet-mobile': fullTabletMobile,
      })}
    >
      {children}
    </div>
  );
  if (Object.keys(wrapperProps).length) {
    return <div {...wrapperProps}>{container}</div>;
  }

  return container;
};

export default Container;

Container.propTypes = {
  children: PropTypes.node,
  extended: PropTypes.bool,
  full: PropTypes.bool,
  main: PropTypes.bool,
  withoutOverflowX: PropTypes.bool,
  narrowPadding: PropTypes.bool,
};

Container.defaultProps = {
  children: null,
  extended: false,
  full: false,
  main: false,
  withoutOverflowX: false,
  narrowPadding: false,
};
